import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#2B604C",
    },
    secondary: {
      main: "#3C47EA",
    },
    info: {
      main: "#0090B7",
    },
    success: {
      main: "#00C9A5",
    },
    error: {
      main: "#E3597A",
    },
    warning: {
      main: "#F9F871",
    },
  },
});
export default theme;
